import { useEffect, useMemo, useRef, useState } from "react";
import { useSuggestionUtils } from "./SuggestionElement";
export function useEnableSuggestionMode() {
    var suggestionElement = useSuggestionUtils();
    return {
        enableSuggestionMode: function (config) {
            if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.enableSuggestionMode))
                return;
            suggestionElement.enableSuggestionMode(config);
        }
    };
}
export function useDisableSuggestionMode() {
    var suggestionElement = useSuggestionUtils();
    return {
        disableSuggestionMode: function () {
            if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.disableSuggestionMode))
                return;
            suggestionElement.disableSuggestionMode();
        }
    };
}
export function useRegisterTarget() {
    var suggestionElement = useSuggestionUtils();
    return {
        registerTarget: function (config) {
            if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.registerTarget))
                return;
            suggestionElement.registerTarget(config);
        }
    };
}
export function useUnregisterTarget() {
    var suggestionElement = useSuggestionUtils();
    return {
        unregisterTarget: function (targetId) {
            if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.unregisterTarget))
                return;
            suggestionElement.unregisterTarget(targetId);
        }
    };
}
export function useStartSuggestion() {
    var suggestionElement = useSuggestionUtils();
    return {
        startSuggestion: function (targetId) {
            if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.startSuggestion))
                return;
            suggestionElement.startSuggestion(targetId);
        }
    };
}
export function useCommitSuggestion() {
    var suggestionElement = useSuggestionUtils();
    return {
        commitSuggestion: function (config) {
            return new Promise(function (resolve, reject) {
                if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.commitSuggestion))
                    return reject(new Error('Velt SDK is not initialized.'));
                suggestionElement.commitSuggestion(config).then(resolve).catch(reject);
            });
        }
    };
}
export function useSuggestionEventCallback(action) {
    var suggestionElement = useSuggestionUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.on, memoizedAction]);
    return data;
}
